import { render, staticRenderFns } from "./operator-form-portfolio.vue?vue&type=template&id=ffd4276c&lang=pug&"
import script from "./operator-form-portfolio.vue?vue&type=script&lang=js&"
export * from "./operator-form-portfolio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports